import { Box, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { useChatAppearance } from '../../core/client/useChatAppearance'

/** A provisional, code-native motif. It can be selected by any client. */
export function SpeechMark() {
  return (
    <Box as='svg' viewBox='0 0 64 64' boxSize={14} color='chat.ink' aria-hidden='true' focusable='false'>
      <path fill='currentColor' d='M32 4a27 27 0 0 0-24 39L4 60l18-4A27 27 0 1 0 32 4Z' />
      <Box as='path' fill='chat.paper' d='M18 27h7v7h-7zM29 27h7v7h-7zM40 27h7v7h-7z' />
    </Box>
  )
}

export function ChatWordmark({ size = 28 }: { size?: number }) {
  const { branding, logoUrl } = useChatAppearance()
  const name = branding?.assistantName || branding?.companyName || ''
  if (logoUrl) {
    return <Image src={logoUrl} alt={name} h={`${size}px`} w='auto' objectFit='contain' flexShrink={0} />
  }
  return (
    <Text fontSize={`${size}px`} fontWeight='700' letterSpacing='-0.5px' lineHeight='1' color='chat.ink'>
      {branding?.assistantName || 'AI chat'}
    </Text>
  )
}
